'use es6';

import { flatten } from 'underscore';
import StatesStatusGroups from 'ContentUtils/constants/StateStatusGroups';
export function findNode(id, tree) {
  for (const node of tree) {
    if (node.id === id) return node;
    if (node.children && node.children.length) {
      const result = findNode(id, node.children);
      if (result) return result;
    }
  }
  return null;
}
export function removeNode(id, tree) {
  for (const node of tree) {
    if (node.id === id) {
      tree.splice(tree.indexOf(node), 1);
      return;
    }
    if (node.children && node.children.length) {
      removeNode(id, node.children);
    }
  }
}
export function getChildIds(node) {
  const childIds = node.children ? node.children.map(getChildIds) : [];
  return flatten(childIds.concat(node.id));
}
export function findNestedParentNode(id, tree) {
  for (const node of tree) {
    if (node.id === id) return node;
    if (node.children && node.children.length) {
      const nestedParentNode = findNestedParentNode(id, node.children);
      const nestedParentNodeExists = nestedParentNode && nestedParentNode.id;
      if (nestedParentNodeExists) return node;
    }
  }
  return {};
}
export const doesMenuContainDraftPages = (menuNodes, pagesById = {}) => {
  return menuNodes.some(menuItem => {
    const pageData = pagesById[menuItem.pageLinkId];
    if (!menuItem.children || !menuItem.children.length) {
      return pageData && !StatesStatusGroups.PUBLISHED.includes(pageData.state);
    }
    return pageData && !StatesStatusGroups.PUBLISHED.includes(pageData.state) || doesMenuContainDraftPages(menuItem.children, pagesById);
  });
};

/**
 * Recursively iterates down each menu node tree and returns the combined set of unique draft pages
 */
export const getUniqueDraftPages = (menuNodes, pagesById = {}, visitedPagesById = {}) => {
  const draftPagesById = menuNodes.reduce((draftPagesByIdAgg, menuItem) => {
    // Retrieve page object
    const pageData = pagesById[menuItem.pageLinkId];

    // If page object is not published, save it in our aggregator
    if (pageData && !StatesStatusGroups.PUBLISHED.includes(pageData.state)) {
      draftPagesByIdAgg[pageData.id] = pageData;
    }

    // Recurse down
    if (menuItem.children && menuItem.children.length > 0) {
      const childDraftPages = getUniqueDraftPages(menuItem.children, pagesById, draftPagesByIdAgg);

      // For any draft page in the recrusive flow, save it to the aggregator
      // Overwrites are fine here
      childDraftPages.forEach(childPage => {
        draftPagesByIdAgg[childPage.id] = childPage;
      });
    }
    return draftPagesByIdAgg;
  }, visitedPagesById);
  return Object.values(draftPagesById);
};